import React from "react";

const Error = () => {
  return (
    <div>
      <h2>there was an error</h2>
    </div>
  );
};
export default Error;
